module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de excepciones de vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud position-relative"
  }, [_c('nueva-solicitud-vacaciones', {
    attrs: {
      "is-excepcion": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarCambioDias) ? _c('div', {
    key: "cambio_dias_solicitud",
    staticClass: "box nueva-solicitud position-relative"
  }, [_c('cambio-dias-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarCambioDias = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b7257c2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Vacaciones_Excepcion.vue
// module id = 833
// module chunks = 0